{
  "de": {
    "qrcodes": {
      "buttons": {
        "generate": "Qrcode generieren"
      }
    }
  }
}
